import { render, staticRenderFns } from "./identityInfo.vue?vue&type=template&id=f16edb0c&"
import script from "./identityInfo.vue?vue&type=script&lang=js&"
export * from "./identityInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports